module.exports = __webpack_public_path__ + "img/cover.1455b114.png";